export default {"src":"/_next/static/image/public/images/ic_read_labreport.c114ec60651f2d5a8111ee62956d6019.svg","height":36,"width":36};